/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LoginResponseModel,
    LoginResponseModelFromJSON,
    LoginResponseModelFromJSONTyped,
    LoginResponseModelToJSON,
} from './LoginResponseModel';
import {
    SocialLoginMessageType,
    SocialLoginMessageTypeFromJSON,
    SocialLoginMessageTypeFromJSONTyped,
    SocialLoginMessageTypeToJSON,
} from './SocialLoginMessageType';

/**
 * 
 * @export
 * @interface LoginResponseWithMessageModel
 */
export interface LoginResponseWithMessageModel {
    /**
     * 
     * @type {SocialLoginMessageType}
     * @memberof LoginResponseWithMessageModel
     */
    type: SocialLoginMessageType;
    /**
     * 
     * @type {string}
     * @memberof LoginResponseWithMessageModel
     */
    message: string;
    /**
     * 
     * @type {LoginResponseModel}
     * @memberof LoginResponseWithMessageModel
     */
    loginResponse?: LoginResponseModel;
}

export function LoginResponseWithMessageModelFromJSON(json: any): LoginResponseWithMessageModel {
    return LoginResponseWithMessageModelFromJSONTyped(json, false);
}

export function LoginResponseWithMessageModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginResponseWithMessageModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': SocialLoginMessageTypeFromJSON(json['type']),
        'message': json['message'],
        'loginResponse': !exists(json, 'loginResponse') ? undefined : LoginResponseModelFromJSON(json['loginResponse']),
    };
}

export function LoginResponseWithMessageModelToJSON(value?: LoginResponseWithMessageModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': SocialLoginMessageTypeToJSON(value.type),
        'message': value.message,
        'loginResponse': LoginResponseModelToJSON(value.loginResponse),
    };
}

